/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * Your Project
 * API for all things …
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  Leave
} from '../../schema'


/**
 * List all Leaves
 */
export const listLeaves = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Leave[]>> => {
    return axios.get(
      `/leaves/`,options
    );
  }


export const getListLeavesQueryKey = () => [`/leaves/`];

    
export type ListLeavesQueryResult = NonNullable<Awaited<ReturnType<typeof listLeaves>>>
export type ListLeavesQueryError = AxiosError<unknown>

export const useListLeaves = <TData = Awaited<ReturnType<typeof listLeaves>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLeaves>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLeavesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeaves>>> = ({ signal }) => listLeaves({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof listLeaves>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Create Leave
 */
export const createLeave = (
    leave: Leave, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Leave>> => {
    return axios.post(
      `/leaves/`,
      leave,options
    );
  }



    export type CreateLeaveMutationResult = NonNullable<Awaited<ReturnType<typeof createLeave>>>
    export type CreateLeaveMutationBody = Leave
    export type CreateLeaveMutationError = AxiosError<unknown>

    export const useCreateLeave = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLeave>>, TError,{data: Leave}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLeave>>, {data: Leave}> = (props) => {
          const {data} = props ?? {};

          return  createLeave(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof createLeave>>, TError, {data: Leave}, TContext>(mutationFn, mutationOptions)
    }
    